import React, { useContext, useEffect } from 'react'
import { WappContext } from 'wapplr-react/dist/common/Wapp'

import Theme from 'vlm-ui/dist/common/src/components/Theme'
import Logo from 'vlm-ui/dist/common/src/components/Logo'
import Typography from 'vlm-ui/dist/common/src/components/Typography'

import themeCritical from './theme/critical.scss'
import defaultThemes from './theme/index.scss'

import appBarStyle from './additionalComponents/appBar.scss'
import avatarStyle from './additionalComponents/avatar.scss'
import imageStyle from './additionalComponents/image.scss'
import inputStyle from './additionalComponents/input.scss'
import labelStyle from './additionalComponents/label.scss'
import logoStyle from './additionalComponents/logo.scss'
import menuStyle from './additionalComponents/menu.scss'
import menuItemStyle from './additionalComponents/menuItem.scss'
import modalStyle from './additionalComponents/modal.scss'
import paperContentStyle from './additionalComponents/paperContent.scss'
import svgIconStyle from './additionalComponents/svgIcon.scss'

import style from './style.css'

const themes = {
    ...Object.keys(defaultThemes).reduce((o, key) => {
        o[key] = [defaultThemes[key], themeCritical[key]].filter((t) => t).join(' ')
        return o
    }, {})
}

const additionalStyles = {
    appBar: appBarStyle,
    avatar: avatarStyle,
    image: imageStyle,
    input: inputStyle,
    label: labelStyle,
    logo: logoStyle,
    menu: menuStyle,
    menuItem: menuItemStyle,
    modal: modalStyle,
    paperContent: paperContentStyle,
    svgIcon: svgIconStyle
}

function LogoWrapper({ ButtonBaseContentComponent }) {
    return (
        <div className={style.logoInner}>
            <ButtonBaseContentComponent />
        </div>
    )
}

export default function App() {
    const context = useContext(WappContext)
    const { wapp, res } = context
    wapp.styles.use(style)

    const agentVer = (wapp.globals && wapp.globals.WAPP) || ''
    let apiVer = ''
    try {
        apiVer = res.wappResponse.store.getState('res.apiVer') || ''
    } catch (e) {
        apiVer = ''
    }

    useEffect(() => {
        if (wapp.target !== 'web') {
            return
        }
        const cssAssets = res.wappResponse.store.getState('res.assets.css') || []
        const themeCss = cssAssets.find((css) => css && css.match && css.match('theme'))
        if (!themeCss || document.getElementById(themeCss)) {
            return
        }
        const criticalCss = cssAssets.find((css) => css && css.match && css.match('critical'))

        function getReference() {
            const { WAPP } = wapp.globals
            const criticalStyle = document.getElementById('css_' + WAPP)
            const criticalLink = criticalCss ? document.getElementById(criticalCss) : null
            return criticalLink || criticalStyle
        }

        async function onThemeLoad() {
            console.log('[AGENT] Full theme loaded...')
            await new Promise((resolve) => setTimeout(resolve, 1500))
            const reference = getReference()
            if (reference && reference.parentNode) {
                reference.parentNode.removeChild(reference)
            }
        }

        function createLink() {
            if (document.getElementById(themeCss)) {
                return
            }
            const head = document.getElementsByTagName('head')[0]
            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.type = 'text/css'
            link.href = themeCss
            link.id = themeCss
            link.onload = onThemeLoad
            const reference = getReference()
            head.insertBefore(link, reference ? reference.nextSibling : null)
        }

        function add() {
            if (!document.getElementById(themeCss)) {
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(createLink)
                } else {
                    createLink()
                }
            }
        }
        function onInteraction(e) {
            if (e.isTrusted) {
                add()
                removeListeners()
            }
        }
        function removeListeners() {
            window.removeEventListener('touchstart', onInteraction)
            window.removeEventListener('mousemove', onInteraction)
        }
        window.addEventListener('touchstart', onInteraction)
        window.addEventListener('mousemove', onInteraction)

        return () => {
            removeListeners()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Theme
            componentsStyle={themes}
            classNames={themes}
            additionalStyles={additionalStyles}
            useStyle={wapp.styles.use}
        >
            <div className={style.app}>
                <div className={style.wrap}>
                    <Logo long={true} Component={LogoWrapper} />
                    <Typography variant={'body'} className={style.ver}>
                        <span>ver: {agentVer} | </span>
                        <span>apiVer: {apiVer}</span>
                    </Typography>
                </div>
            </div>
        </Theme>
    )
}
